import React from 'react'
import PropTypes from 'prop-types'
import ModalFooter from 'components/ModalFooter'
import ModalHeader from 'components/ModalHeader'
import ModalIntro from 'components/ModalIntro'
import Prepare from './Prepare'
import { StyledModal } from './component.styles'

const KickoffModal = ({
  currentStep,
  flowLabel,
  goBack,
  handleClose,
  handleNextButtonClick,
  modals,
}) => {
  const currentModal = modals?.[currentStep] || {}
  const { helpCopy, nextLabel } = currentModal

  return (
    <StyledModal
      dataTestId="kickoff-modal"
      isModalOpen={true}
      modalClose={() => handleClose}
    >
      <ModalHeader
        flowLabel={flowLabel}
        handleClose={handleClose}
        handleGoBack={goBack}
        showBackButton={currentStep !== 0}
      />
      {currentStep === 0 && <ModalIntro modalData={modals[0]} />}
      {currentStep === 1 && <Prepare modalData={modals[1]} />}
      <ModalFooter
        handleNextButtonClick={handleNextButtonClick}
        helpCopy={helpCopy}
        isValid={true}
        modalName="kickoff"
        nextButtonText={nextLabel}
        showCancelButton={false}
      />
    </StyledModal>
  )
}

KickoffModal.propTypes = {
  currentStep: PropTypes.number,
  flowLabel: PropTypes.string,
  goBack: PropTypes.func,
  handleClose: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  modals: PropTypes.array,
}

export default KickoffModal
